import { useFormContext } from 'react-hook-form';
import RootInput from 'components/Input/RootInput/RootInput';
import { type RootInputProps } from 'components/Input/RootInput/types';
import { SSN_MASK_OPTIONS, SSN_PLACEHOLDER } from './config';

type Props = Pick<RootInputProps, 'name' | 'label' | 'required' | 'containerClassName'>;

const SsnInput = (props: Props) => {
  const { name, label, containerClassName, required } = props;

  const { control, clearErrors } = useFormContext();

  return (
    <RootInput
      key="ssn"
      name={name}
      label={label}
      control={control}
      clearErrors={clearErrors}
      maskOptions={SSN_MASK_OPTIONS}
      placeholder={SSN_PLACEHOLDER}
      containerClassName={containerClassName}
      required={required}
      inputMode="numeric"
      spellCheck={false}
    />
  );
};

export default SsnInput;
